import React from 'react';

import Search from './Search';
import SidebarCategories from './SidebarCategories';
import PopularPosts from './PopularPosts';
import TagCloud from './TagCloud';

/**
 * RightSidebar Component
 * Renders the right-side content panel with search, categories, popular posts, and tags.
 */
const RightSidebar = () => {
    return (
        <aside className="sidebar">
            <Search />
            <SidebarCategories />
            <PopularPosts />
            <TagCloud />
        </aside>
    );
};

export default React.memo(RightSidebar);
